<template>
  <div class="yxtbiz-ai-create-ques-quick">
    <ai-textarea
      ref="txtAsk"
      v-model="inputTxt"
      maxlength="10000"
      @save="convertToQues()"
      @focus="focusInput"
      hide-btn
      :placeholder="$t('pc_biz_ote_tip_entercontent' /** 请输入内容 */)"
    >
      <div slot="header">
        {{ $t('pc_biz_ote_lbl_enterbytemplate' /** 请按照要求格式输入： */) }}
        <yxt-button type="text" @click="openSelectStandardFormatExample">{{
          $t('pc_biz_ote_lbl_sample' /** 查看标准格式示例 */)
        }}</yxt-button>
      </div>
    </ai-textarea>
    <div class="flex flex-shrink-0 mt16 flex-top">
      <div class="flex-shrink-0 mr8 color-gray-10">
        {{$t('pc_biz_ote_lbl_questiontypesetas' /** 设为 */)}}
      </div>
      <div class="yxtbiz-ai-break-tags">
        <template v-for="(kw, index) in keywords.quesType">
          <yxt-button :key="kw" type="text" @click="addType(0, index)">
            {{ kw.replace('[', '').replace(']', '') }}
          </yxt-button> 
        </template>
      </div>
    </div>
    <div class="flex flex-shrink-0">
      <div class="flex-shrink-0 mr8 color-gray-10">
        {{$t('pc_biz_ote_lbl_queslevel' /** 难度 */)}}
      </div>
      <div class="yxtbiz-ai-break-tags">
        <template v-for="(kw, index) in keywords.levelTypeSorted">
          <yxt-button :key="kw" type="text" @click="addType(1, index)">
            {{ kw.replace('[', '').replace(']', '') }}
          </yxt-button>
        </template>
      </div>
    </div>
    <div class="flex flex-shrink-0 color-gray-7">
        {{$t('pc_biz_ote_lbl_notemousercursor' /** 注：把鼠标光标放置某个题干后，然后点击上述的题型 */)}}
    </div>
    <yxt-button
      class="yxtbiz-ai-create-ques-btn flex-g-1 mt16"
      type="primary"
      size="large"
      @click="convertToQues()"
      :disabled="!inputTxt"
    >
      {{ $t('pc_biz_ote_btn_genques' /** 生成试题 */) }}
    </yxt-button>
    <!-- 打开示例 -->
    <ques-standard-format-example-a-i
      :states="selectStandardFormatExample"
      @closeStandardFormatExample="closeStandardFormatExample"
    ></ques-standard-format-example-a-i>
  </div>
</template>

<script>
import aiTextarea from '../components/aiTextarea.vue';
import quesStandardFormatExampleAI from './components/quesStandardFormatExampleAI.vue';
import { SvgMediaNewUrl } from '../const';
import {
  analysisInputText,
  getAnalysedQuesList,
  getAIQuesPromptKeywords
} from '../utilsForAI';

export default {
  components: { quesStandardFormatExampleAI, aiTextarea },
  props: {
    libId: {
      type: String,
      default: ''
    },
    libName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectStandardFormatExample: {
        isShowStandardFormatExample: false
      },
      inputTxt: '',
      keywords: getAIQuesPromptKeywords(),
      SvgMediaNewUrl
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.txt = val;
      }
    }
  },
  mounted() {},
  methods: {
    // 打开示例抽屉
    openSelectStandardFormatExample() {
      this.selectStandardFormatExample.isShowStandardFormatExample =
        !this.selectStandardFormatExample.isShowStandardFormatExample;
    },
    // 关闭示例抽屉
    closeStandardFormatExample() {
      this.selectStandardFormatExample.isShowStandardFormatExample = false;
    },
    convertToQues() {
      const analysisData = analysisInputText(this.inputTxt, false, true);

      const quesList = getAnalysedQuesList(
        analysisData.questions,
        this.libId,
        this.libName
      );

      if (!quesList || quesList.length === 0) {
        // this.$message({
        //   message: this.$t(
        //     'pc_biz_ote_msg_ainotavalid' /** 当前使用人数过多，请稍后再试 */
        //   ),
        //   type: 'error'
        // });
        return;
      }

      this.$emit(
        'addQues',
        quesList,
        added => {
          if (added) {
            this.inputTxt = '';
          }
        },
        1
      );
    },

    /**
     * 添加类型
     * param type int（0:试题、1:难易度、2:答案）
     * param index int 试题、难易度、答案的类型
     */
    addType(type, index, before = true) {
      this.textLine = this.inputTxt.split('\n');
      const pos = this.getPosLine();
      let typeJson = {};
      const keyAnswers = [
        // this.keywords.explain + ': ',
        // this.keywords.answer + ': '
      ];
      switch (type) {
        case 0:
          typeJson = [...this.keywords.quesType, ...keyAnswers];
          break;
        case 1:
          typeJson = [...this.keywords.levelTypeSorted, ...keyAnswers];
          break;
        case 2:
          typeJson = [...this.keywords.judgeAnswer, ...keyAnswers];
          break;
        case 3:
          typeJson = [
            ...keyAnswers,
            ...this.keywords.quesType,
            ...this.keywords.levelTypeSorted,
            ...this.keywords.judgeAnswer
          ];
          break;
      }
      const typeValue = typeJson[index];
      if (pos < this.textLine.length) {
        let content = this.textLine[pos];

        // 去除同类标记
        for (const i in typeJson) {
          content = content.replace(typeJson[i], '');
        }

        let c = '';
        for (let j = 0; j < this.textLine.length; j++) {
          if (j !== pos) {
            c += this.textLine[j];
            if (j < this.textLine.length - 1) {
              c += '\n';
            }
          } else {
            c +=
              ((before && typeValue) || '') +
              content.replace('\r', '') +
              ((!before && typeValue) || '') +
              '\n';
          }
        }
        this.inputTxt = c;
      } else {
        this.insertAtCursor(typeValue);
      }
    },
    // 插入光标
    insertAtCursor(c) {
      const d = this.$refs.txtAsk.getInput();
      if (document.selection) {
        d.focus();
        const sel = document.selection.createRange();
        sel.text = c;
      } else {
        if (
          d.selectionStart === d.selectionEnd &&
          d.selectionStart === d.value.length
        ) {
          // 请先将光标移动到要插入题型的位置
          this.$alert(
            this.$t('pc_ote_msg_cursormoveqtypepos'),
            this.$t('pc_ote_msg_tip'),
            {
              confirmButtonText: this.$t('pc_ote_btn_confirm')
            }
          );
        } else {
          if (d.selectionStart || d.selectionStart === '0') {
            const b = d.selectionStart;
            const a = d.selectionEnd;
            d.value =
              d.value.substring(0, b) +
              c +
              d.value.substring(a, d.value.length);
          } else {
            d.value += c;
          }
        }
      }
    },
    // 获取当前位置
    getPosLine() {
      if (this.lastCaretPos !== undefined) {
        return this.lastCaretPos;
      }
      let d = this.getCaret();
      let a = 0;
      let c = 0;
      for (let b = 0; b < this.textLine.length; b++) {
        c += this.textLine[b].length + 1;
        if (d < c) {
          a = b;
          break;
        }
      }
      this.lastCaretPos = a;
      return a;
    },
    getCaret() {
      const b = this.$refs.txtAsk.getInput();
      if (b.selectionStart) {
        const c = this.getLastEnter(b.value, b.selectionEnd);
        return b.selectionStart - c;
      } else {
        if (document.selection) {
          b.focus();
          const c1 = document.selection.createRange();
          if (c1 === null) {
            return 0;
          }
          const a = b.createTextRange();
          const d = a.duplicate();
          a.moveToBookmark(c1.getBookmark());
          d.setEndPoint('EndToStart', a);
          return d.text.length;
        }
      }
      return 0;
    },
    // 得到参数字符串右侧的换行符号个数
    getLastEnter(str, pos) {
      const isLineLast = str.substring(pos, str.length).indexOf('\n') === 0;
      if (!isLineLast) {
        return 0;
      }

      str = str.substring(0, pos);
      const l1 = str.length;
      const l2 = str.replace(/[.\n]*$/g, '').length;
      return l1 - l2;
    },
    focusInput() {
      this.lastCaretPos = undefined;
    }
  },
  beforeDestroy() {}
};
</script>
